var defaultTheme = {
    action: "#482DEB",
    warning: "#FF9911",
    negative: "#EC0049",
    positive: "#008800",
    neutral: "#006FFB",
};
var staticColors = {
    "color-white": "#FFFFFF",
    "color-black": "#1A1B23",
    "color-slate": "#6f749b",
};
var interfaceColors = {
    "color-ui-interface": "#556680",
    "color-ui-interface-mid": "#39465b",
    "color-ui-interface-dark": "#262e3b",
    "color-ui-interface-5": "#F7FAFD",
    "color-ui-interface-10": "#F0F4FA",
    "color-ui-interface-20": "#E4ECF6",
    "color-ui-interface-30": "#D7E1EF",
    "color-ui-interface-40": "#BBCADD",
    "color-ui-interface-50": "#A6B7CE",
    "color-ui-interface-60": "#93A5BD",
    "color-ui-interface-70": "#8598B2",
    "color-ui-interface-80": "#7586A3",
    "color-ui-interface-90": "#667793",
};
var dataColors = {
    "color-data-green": "#39A775",
    "color-data-cyan": "#28A2B9",
    "color-data-light-blue": "#3E97F8",
    "color-data-purple": "#6164EA",
    "color-data-violet": "#9A65E7",
    "color-data-pink": "#E75A85",
    "color-data-orange": "#F5923E",
};
var defaultShades = {
    action: {
        mid: "#2F1BA6",
        dark: "#15095D",
    },
    warning: {
        mid: "#DB7D00",
        dark: "#754300",
    },
    negative: {
        mid: "#B80039",
        dark: "#750024",
    },
    positive: {
        mid: "#006100",
        dark: "#004D00",
    },
    neutral: {
        mid: "#0058C7",
        dark: "#004194",
    },
};

export { dataColors as a, defaultShades as b, defaultTheme as d, interfaceColors as i, staticColors as s };
